
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game/[slug]",
      function () {
        return require("private-next-pages/game/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/game/[slug]"])
      });
    }
  